import Footer from './Footer';
import Header from './home/Header';

export default function LayoutWithHeaderFooter({ children }) {
  return (
    <>
    <Header />
      {children}
      <Footer/>
    </>
  );
}